var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "manage-users-row flex row" }, [
    _vm.user.profilePicture
      ? _c("img", {
          staticClass: "logo",
          attrs: { src: _vm.logo, alt: "User Image" },
        })
      : _c("div", { staticClass: "logo" }, [
          _c("i", { staticClass: "material-icons" }, [_vm._v("person")]),
        ]),
    _c(
      "div",
      {
        staticClass: "details flex column",
        class: _vm.user.type.toLowerCase(),
      },
      [
        _c("div", { staticClass: "name" }, [
          _vm._v(" " + _vm._s(_vm.user.fullName) + " "),
        ]),
        _c(
          "div",
          { staticClass: "top flex" },
          [
            _c(
              "i",
              { staticClass: "material-icons", class: { admin: _vm.isAdmin } },
              [_vm._v(" account_circle ")]
            ),
            _c(
              "div",
              { staticClass: "position" },
              [
                _vm.isAdmin
                  ? [_vm._v(" Admin ")]
                  : [_vm._v(" Account Manager ")],
              ],
              2
            ),
            _vm.isUnverified
              ? [
                  _c("span", { staticClass: "dot" }, [_vm._v("·")]),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("access_time"),
                  ]),
                  _vm._v(" Account Deactivated "),
                ]
              : _vm.isPending
              ? [
                  _c("span", { staticClass: "dot" }, [_vm._v("·")]),
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("access_time"),
                  ]),
                  _vm._v(" Pending Acceptance "),
                ]
              : _vm._e(),
          ],
          2
        ),
        _c("div", { staticClass: "contact flex" }, [
          _c("div", [_vm._v(_vm._s(_vm.user.emailAddress))]),
          _vm.user.emailAddress && _vm.user.phone
            ? _c("span", { staticClass: "dot" }, [_vm._v(" · ")])
            : _vm._e(),
          _c("div", [_vm._v(_vm._s(_vm.user.phone))]),
        ]),
      ]
    ),
    _c(
      "div",
      { staticClass: "actions flex row" },
      [
        _vm.currentUserIsAdmin
          ? _c(
              "dropdown-actions",
              {
                staticClass: "light",
                attrs: { items: _vm.actions, value: {} },
                on: { input: _vm.executeAction },
              },
              [
                _c("template", { slot: "value" }, [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("settings"),
                  ]),
                  _vm._v(" Manage "),
                ]),
              ],
              2
            )
          : _vm._e(),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }